import {Component, OnInit} from '@angular/core';
import {SalesRequestCreditBureauComponent} from '../sales-request-credit-bureau.component';

@Component({
  selector: 'app-sales-request-credit-bureau-v3',
  templateUrl: './sales-request-credit-bureau-v3.component.html',
})
export class SalesRequestCreditBureauComponentV3 extends SalesRequestCreditBureauComponent implements OnInit {
  override ngOnInit() {
    this.loadDocument();
  }
}